module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-light.f803fe17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-arrow-down-light.svg
// module id = 475
// module chunks = 7